import styled from 'styled-components';

export const BaseDiv = styled.div`
`;